import  { useState, useEffect } from "react";

const useTelemetry = () => {
  const [telemetryEnabled, setTelemetryEnabled] = useState();

  const handleTelemetryValue = (buttonClicked) => {
    if (buttonClicked === "Accept") {
      setTelemetryEnabled(true);
    } else if (buttonClicked === "Reject") {
      setTelemetryEnabled(false);
    }
  };

  useEffect(() => {
    console.log('Telemetry enabled:', telemetryEnabled);
  }, [telemetryEnabled]);

  return { telemetryEnabled, handleTelemetryValue };
};

export default useTelemetry;